import { render, staticRenderFns } from "./MyEventReadOnly.vue?vue&type=template&id=5a6d9755&scoped=true&"
import script from "./MyEventReadOnly.vue?vue&type=script&lang=js&"
export * from "./MyEventReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./MyEventReadOnly.vue?vue&type=style&index=0&id=5a6d9755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d9755",
  null
  
)

export default component.exports